export const seniorBusinessDevelopmentResume = `
【職務概要】
事業開発のプロフェッショナルとして15年以上の経験を持ち、新規事業立案から市場投入、アライアンス構築、事業拡大までの一連のプロセスを数多く手掛けてきました。特にDX・AI領域、物流自動化、SaaS事業において豊富な実績があります。戦略コンサルティングで培った論理的思考と分析力を基盤に、ビジネス構想力と実行力を兼ね備えた事業開発を得意としています。

大手企業からスタートアップまで幅広い環境で、経営層への提案・折衝を含む複雑な利害関係の調整や、クロスファンクショナルなチームマネジメントを通じて事業の立ち上げと成長を牽引してきました。市場分析からビジネスモデル設計、パートナーシップ構築、収益化モデルの確立まで、事業開発の全フェーズを統括してきた経験があります。常に最新の技術動向とビジネストレンドにアンテナを張り、イノベーションの機会を見極め、組織の成長と事業拡大に貢献してきました。

【職務経歴】
・株式会社AlgomaticDX（2020年4月〜現在）
 ○会社概要：AI・データ活用による企業のDX支援を行うテクノロジー企業（従業員150名）
 ○就業期間：2020年4月〜現在
 ○職務内容：事業開発本部 部長
  - 大企業向けAIソリューション事業の新規立ち上げと事業拡大
  - 生成AI活用による業務効率化ソリューションの企画・開発・販売戦略策定
  - エンタープライズ向けSaaSプロダクトの市場投入戦略立案と実行
  - アライアンス戦略の策定と実行（ベンダー・リセラー含む30社以上との提携）
  - 事業開発チーム（15名）のマネジメント
 ○具体的な成果：
  - 生成AIを活用した業務効率化ソリューションを開発、2年で売上高15億円の事業に成長
  - 大手製造業5社とのPoC実施からビジネス化までのプロセスを確立、成約率を35%→65%に向上
  - 新規事業においてARR（年間経常収益）8億円を達成、前年比300%成長を実現
  - 金融・製造・流通領域での業界特化型AIソリューションの開発をリード
 ○使用した技術・ツール：
  - 戦略フレームワーク（SWOT分析、5Forces、バリューチェーン分析等）
  - CRM（Salesforce）、データ分析ツール（Tableau、PowerBI）
  - プロジェクト管理ツール（Jira、Asana）
 ○身につけたスキルや知識：
  - 生成AI技術の産業応用に関する知見
  - エンタープライズSaaSの収益モデル設計と最適化
  - 複数のステークホルダーを巻き込んだ大規模プロジェクト推進力

・株式会社Algomaticコンサルティング（2014年7月〜2020年3月）
 ○会社概要：大手戦略コンサルティングファーム（従業員500名）
 ○就業期間：2014年7月〜2020年3月
 ○職務内容：シニアマネージャー
  - 製造業・IT業界を中心とした事業戦略策定、新規事業開発支援
  - デジタルトランスフォーメーション領域のコンサルティングサービス立ち上げ
  - クライアント企業の経営層に対する戦略提案と実行支援
  - 業界・市場分析、競合分析、中長期戦略策定支援
  - コンサルタントチーム（3〜8名）のプロジェクトマネジメント
 ○具体的な成果：
  - 大手製造業のDX戦略立案と実行支援により、3年で売上高10%増、営業利益率5%改善に貢献
  - 中堅ITベンダーの新規事業立ち上げ支援で、2年で売上20億円の事業を創出
  - 自社内DX領域のサービスライン立ち上げにより、部門売上を年率35%成長させる
  - 顧客満足度調査で部門内トップ評価（4.8/5.0）を3年連続獲得
 ○使用した技術・ツール：
  - 経営分析フレームワーク、財務モデリングツール
  - 市場調査・分析手法（デプスインタビュー、アンケート設計等）
  - プレゼンテーションツール（PowerPoint、Prezi）
 ○身につけたスキルや知識：
  - 多様な業界（製造、IT、小売、物流等）の事業構造と課題理解
  - デジタル技術を活用した業務改革・事業変革の方法論
  - 経営層への影響力のある提案・プレゼンテーションスキル

・株式会社Algomatic産業（2009年4月〜2014年6月）
 ○会社概要：総合商社（従業員3,000名）
 ○就業期間：2009年4月〜2014年6月
 ○職務内容：事業開発部 課長
  - 新興国向け物流インフラ事業の企画・立案
  - 先端技術領域におけるベンチャー企業への投資・提携戦略策定
  - 物流自動化システムの国内展開事業の立ち上げ
  - クロスボーダーM&A案件の発掘・交渉・PMI（買収後統合）支援
 ○具体的な成果：
  - 東南アジアでの物流インフラ事業の立ち上げにより、3年で売上高30億円を達成
  - 物流自動化ベンチャー2社への戦略投資（総額15億円）をリード
  - 社内新規事業コンテストで最優秀賞を受賞、経営会議で事業化承認を獲得
  - 物流自動化システムの国内展開で初年度から黒字化を実現
 ○使用した技術・ツール：
  - 事業性評価モデル、投資判断指標（IRR、NPV等）
  - 海外市場調査手法、現地パートナー評価フレームワーク
  - 財務・会計ツール（Excel高度モデリング）
 ○身につけたスキルや知識：
  - 国際的な事業開発・提携交渉スキル
  - 新興国市場におけるビジネス開発手法
  - 物流自動化技術の理解と市場応用力

【受賞・表彰歴】
・2023年 株式会社AlgomaticDX 「イノベーション大賞」受賞
 （生成AI活用ソリューションの開発と事業化による功績）
・2021年 一般社団法人日本DX推進協会 「DXリーダー賞」受賞
 （AI技術の産業応用推進による日本企業のDX貢献）
・2019年 株式会社Algomaticコンサルティング 「ベストプロジェクトリーダー賞」受賞
 （製造業のデジタル変革プロジェクトの成功的推進）
・2017年 ビジネス雑誌「月刊イノベーターズ」 「次世代ビジネスリーダー100人」選出

【資格】
・PMP（Project Management Professional）（2016年3月）
・中小企業診断士（2015年4月）
・ITストラテジスト（2013年10月）
・TOEIC 920点（2021年6月更新）

【マネジメント経験】
・株式会社AlgomaticDXにて事業開発チーム（15名）のマネジメント（2020年4月〜現在）
 ○事業企画担当5名、パートナーアライアンス担当4名、セールスイネーブルメント担当6名
 ○新卒〜中途採用者まで幅広い人材のマネジメント、育成
 ○部門業績目標の達成（前年比130%の売上成長を3年連続達成）
 ○メンバーからのマネジメント満足度調査で4.6/5.0の高評価獲得
・株式会社Algomaticコンサルティングにてプロジェクトチーム（3〜8名）のマネジメント
 ○18のプロジェクトをリード、クライアント評価平均4.8/5.0を獲得
 ○若手コンサルタントの育成プログラムを企画・実施、社内研修講師を担当
 ○メンターとして10名の若手コンサルタントの育成に貢献

【語学力】
・英語：ビジネスレベル
 ○TOEIC 920点
 ○海外投資家・パートナーとの交渉、契約書の作成・レビュー
 ○国際会議でのプレゼンテーション、英文技術資料の理解
 ○海外拠点（シンガポール、サンフランシスコ）との定期的なコミュニケーション
` as const;
